import { useState, type ReactElement } from 'react'
import { Branch } from './tree-topology/tree-topology.parts'
import { buildBranchLines, type TreeNode } from './tree-topology/tree-topology.helpers'

interface TreeTopologyProps {
  nodes: TreeNode[]
  lanGroupId: number
  onToggleCollapse?: (endpointId: string) => void
  onToggleCollapseRecursive?: (endpointId: string) => void
}

export function TreeTopology({
  nodes,
  lanGroupId,
  onToggleCollapse,
  onToggleCollapseRecursive,
}: TreeTopologyProps): ReactElement | null {
  const [hoveredParentId, setHoveredParentId] = useState<string | null>(null)

  if (nodes.length === 0) return null

  const branchLines = buildBranchLines(nodes)

  return (
    <g data-tree-topology={lanGroupId}>
      {branchLines.map((branch) => (
        <Branch
          key={branch.parentId}
          branch={branch}
          hovered={hoveredParentId === branch.parentId}
          onHover={setHoveredParentId}
          onToggleCollapse={onToggleCollapse}
          onToggleCollapseRecursive={onToggleCollapseRecursive}
        />
      ))}
    </g>
  )
}

export default TreeTopology
